import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { TaxesBanner } from 'components/generic/TaxesBanner.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import PadLock from 'lib/components/PadLock';

import CN from './HeaderStocksNavigation.module.scss';

const HeaderStocksNavigation = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const salonId = useCurrentSalonId();

  return (
    <div
      data-bem="HeaderStocksNavigation"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <TaxesBanner location="product" />
      <header data-bem="HeaderStocksNavigation__header" className={CN.header}>
        <SidebarMenu />
        <div className={CN.globalNav}>
          <div className={CN.pageName}>{t('stocks.headerNavigation.title')}</div>
          <nav className={CN.menuList}>
            <ul className={CN.ulScrollMenu}>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksManager, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.stockManager')}
                </NavLink>
              </li>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksUsedSold, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.usedStock')}
                </NavLink>
              </li>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksMovement, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.lastStockMovement')}
                </NavLink>
              </li>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksHolding, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.stockOrdering')}
                </NavLink>
              </li>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksOrderReceived, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.ordersReceived')}
                </NavLink>
              </li>
              <li className={CN.item}>
                <NavLink to={linkTo({ pattern: LINK.stocksCustomAuth, params: { salonId }, fault: '#' })} activeClassName={CN.selected} className={CN.link}>
                  {t('stocks.headerNavigation.syncScanner')}
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <PadLock inMenu />
      </header>
    </div>
  );
};

export default HeaderStocksNavigation;
